var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogsearchnew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1224 17.188H18.1036L17.7425 16.8398C18.5485 15.9034 19.1375 14.8005 19.4675 13.61C19.7974 12.4194 19.8602 11.1707 19.6512 9.95305C19.0451 6.36783 16.0531 3.50482 12.4421 3.06634C11.1726 2.90573 9.88314 3.03767 8.67246 3.45206C7.46179 3.86644 6.36196 4.55229 5.45713 5.45713C4.55229 6.36196 3.86644 7.46179 3.45206 8.67246C3.03767 9.88314 2.90573 11.1726 3.06634 12.4421C3.50482 16.0531 6.36783 19.0451 9.95305 19.6512C11.1707 19.8602 12.4194 19.7974 13.61 19.4675C14.8005 19.1375 15.9034 18.5485 16.8398 17.7425L17.188 18.1036V19.1224L22.669 24.6034C23.1977 25.1322 24.0618 25.1322 24.5905 24.6034C25.1193 24.0747 25.1193 23.2106 24.5905 22.6819L19.1224 17.188ZM11.3846 17.188C8.17334 17.188 5.58115 14.5958 5.58115 11.3846C5.58115 8.17334 8.17334 5.58115 11.3846 5.58115C14.5958 5.58115 17.188 8.17334 17.188 11.3846C17.188 14.5958 14.5958 17.188 11.3846 17.188Z",
    fill: "#4D3ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogsearchnew);
export default __webpack_public_path__ + "static/media/blogsearchnew.b95fd8be455706c4658a3f27933f5186.svg";
export { ForwardRef as ReactComponent };